module.exports = __webpack_public_path__ + "img/img6.4279ca79.jpg";